import { Controller } from "@hotwired/stimulus"

// Reusable live search — debounces input and auto-submits the form.
// Attach to a <form> element. Any input/change event from child elements
// triggers a debounced form submission via Turbo Frame.
//
// Usage:
//   <form action="/search" method="get" data-turbo-frame="results"
//         data-controller="live-search">
//     <input type="text" name="q" data-action="input->live-search#search" />
//     <!-- styled_select dispatches change events, caught by: -->
//     <!-- data-action="change->live-search#search" on the form -->
//   </form>
//
// Values:
//   delay: debounce milliseconds (default 300)
export default class extends Controller {
  static values = { delay: { type: Number, default: 300 } }

  connect() {
    this._timeout = null
  }

  disconnect() {
    if (this._timeout) clearTimeout(this._timeout)
  }

  search() {
    if (this._timeout) clearTimeout(this._timeout)

    this._timeout = setTimeout(() => {
      this.element.requestSubmit()
    }, this.delayValue)
  }
}
